export const SKU_SEPARATOR = "#";
export const MEDICAL_ASSESSMENT_ID = "xhuRrhH9";
export const CDCDPP_ELIGIBILITY_QUESTIONNAIRE_ID = "h7S07G4Y";
export const CSAT_FEEDBACK_QUESTIONNAIRE_ID = "fnZKqImJ";

export const FEEDBACK_GOOD_QUESTIONNAIRE_ID = "RbfVQcyi";
export const FEEDBACK_BAD_QUESTIONNAIRE_ID = "fpmAyZSJ";
export const RISK_QUIZ_QUESTIONNAIRE_ID = "UdChB1PZ";
export const PTHW_BINARY_RATING_QUESTIONNAIRE_ID = "Wz332UwZ";

export const GLP1_REFILL_QUESTIONNAIRE_ID = "HYhrpTHZ";
export const GLP1_CONTINUATION_QUESTIONNAIRE_ID = "a4GxqpNY";
export const GLP1_CONTINUATION_MEDICATION_LEFT_QUESTION_ID = "UUeznpkuACcR";

export const FUNNEL_QUESTIONNAIRE_ELIGIBILITY = "J3TCSVXD";
export const FUNNEL_QUESTIONNAIRE_MEDICAL = "wRvs6BNP";
export const ONBOARDING_QUESTIONNAIRE_INITIAL_LAB = "OgCAbwRC";

export const EMPLOYER_QUESTIONNAIRE_ID = "nnr4MisyYRqS";
export const LANGUAGE_QUESTIONNAIRE_ID = "AiLU5TePO0Rn";

export const METADATA_CONTENT_VALUE = "content-value:generated";
export const METADATA_MESSAGE_TYPE = "message:type";
export const METADATA_ORIGINAL_SOURCE = "message:original-source";

export const METADATA_ORIGINAL_SOURCE_9AM_FRONTEND = "9am-frontend";

export const FEEDBACK_GOOD_QUESTIONNAIRE_RATING_QUESTION_ID = "IO6j6rqY1RZe";
export const FEEDBACK_GOOD_QUESTIONNAIRE_RATING_TEXT_QUESTION_ID =
  "jbcJT8E3mSDu";
export const FEEDBACK_BAD_QUESTIONNAIRE_RATING_TEXT_QUESTION_ID =
  "kOo6PZPaJrP4";

export const COACHING_RATING_QUESTIONNAIRE_ID = "T9NcMDgT";

export const APPOINTMENT_RATING_QUESTIONNAIRE_ID = "BWLGIh7I";

export const LYRA_HEALTH_URL = `https://lyra.app.link/directPathBooking?directPath=true&treatmentOption=individualTherapy&directLinkIntent=DIRECT_LINK_INTENT_HEALTHY_LIFESTYLE&directLinkSource=9am_health&utm_source=9am%20Health&authLanding=registration&$fallback_url=${encodeURIComponent("https://amazon.lyrahealth.com/secure/onboard/match-location")}`;

export const PHLEBOTOMY_SKU = "AT_HOME_PHLEBOTOMY"; // At home lab
export const BLOOD_SPOT_SKU = "DRY_BLOOD_SPOT_LAB_TEST"; // Regular lab
export const BASE_MEMBERSHIP_SKU = "base_membership";
export const ONBOARDING_FEE_SKU = "care:onboarding";

export const SUBSCRIPTION_PLAN_ID_MEDICARE =
  "a0f4517f-b826-470d-9826-bd47ed05e76c";
export const SUBSCRIPTION_PLAN_ID_PRESCRYPTIVE =
  "858bc430-fb92-4b25-bf66-e3a1cebf7ab7";
export const SUBSCRIPTION_PLAN_ID_CDCDPP =
  "9d9a2bc1-4fb2-4d35-b7af-edfc7ef3eb70";

export const AVERAGE_DELIVERY_LENGTH_IN_DAYS = 4;

export const METADATA_NEW_MEDS_KEY = "medication.new-med-for-patient";
export const METADATA_DAILY_DOSAGE_TIMES = "medication.daily-dosage-times";
export const METADATA_RAMPING_UP_DOSAGE = "medication.ramping-up-dosage";

export const METADATA_NPS_FEEDBACK_RATING = "nps-feedback:rating";
export const METADATA_NPS_FEEDBACK_RATING_NUMBER = "nps-feedback:ratingNumber";
export const METADATA_NPS_FEEDBACK_RATING_TEXT = "nps-feedback:ratingText";
export const METADATA_NPS_FEEDBACK_SOURCE_ID = "nps-feedback:sourceId";

export const METADATA_CSAT_FEEDBACK_REPLY = "csat-feedback:reply";
export const METADATA_CSAT_FEEDBACK_SOURCE_ID = "csat-feedback:sourceId";

export const ANDROID_APP_DOWNLOAD_LINK =
  "https://play.google.com/store/apps/details?id=com.join9am.app.android";
export const IOS_APP_DOWNLOAD_LINK =
  "https://apps.apple.com/us/app/9am-at-home-diabetes-clinic/id6443864010";

/**
 * Production "download the app" landing URL. Hardcoded to prod (not the
 * env-specific WEB_URL) so QR codes shown on non-prod desktops still resolve to
 * a real, scannable destination.
 */
export const APP_DOWNLOAD_QR_URL = "https://app.join9am.com/download-app";

export const END_OF_DAY = {
  hour: 23,
  minute: 59,
  second: 59,
  millisecond: 999
};
export const START_OF_DAY = {
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
};
export const END_OF_HOUR = {
  minute: 59,
  second: 59,
  millisecond: 999
};
export const START_OF_HOUR = {
  minute: 0,
  second: 0,
  millisecond: 0
};

const max32BitInt = 2147483647;
export const MAX_TIMEOUT = max32BitInt - 1;
export const NON_BREAKING_SPACE = "\u00A0";
